<template>
<div>
    <!-- <headerComponent/> -->
    <div class="pageContainer">
        <!-- <carousel :perPage="1" :autoplay="true" :loop="true" style="height:540px">  
            <slide v-for="image in images" :key="image">  
                <img :src="require(`${image}`)" alt="carousel image">  
            </slide>  
        </carousel>   -->
         <img :src="curImg.src" alt="" srcset="" style="width:100%;"  class="animate__animated animate__slideInLeft">

    </div>
    <div class="containerOne" style="width:100%;min-height:820px;margin:45px 0 0 0">
      <div style="width:1300px;margin:0 auto">
        <!-- <img src="@/views/solution/images/group02.png" alt="" srcset="" style="width:100%;padding:30px 0 0px 0;display:block;margin-bottom:60px;"> -->
        <!-- 公共组建开始 -->
        <module-tit :title="newsInfo?.cateInfo?.sub_name" :subTitle="newsInfo?.cateInfo?.name" titleStyle="width:255px" subTitleStyle="width:1040px"/>
        <!-- 公共组件结束 -->
        <div class="one animate__animated animate__fadeIn" style="position:relative;width:100%;height:250px;background:#fff;" v-for="(item,index) in newsInfo.data" :key="index" @click="handleDetail(item)"   v-animate-onscroll="'animate__animated animate__fadeIn'" >
          <img :src="item.thumb" alt="" srcset="" style="width:30%;height:250px;display:block;float:right">
          <div class="module" style="width:70%;height:100%;float:left;padding:75px 40px 20px 30px">
            <div class="left" style="float:left;text-aling:center;padding:0 50px;">
              <span style="font-size:80px;padding:0 0px 40px 0;font-weight:700;display:block;border-bottom:3px solid red;text-align:center;width:84px;color:#5b5b5b">{{ item.create_time | filterDay}}</span>
              <span style="font-size:22px;text-align:center;display:block;padding:20px 0 0 0">{{ item.create_time | filterYear}}-{{ item.create_time | filterMonth}}</span>
            </div>
            <div class="right" style="float:left;width:70%;margin:-20px 0 0 0;padding:0 0 0 20px;border-left:1px solid red">
              <span style="display:block;border-bottom:1px solid #a8a8a8;padding:0px 0 20px 0;font-size:22px;font-weight:700">{{item.title}}</span>
              <span style="padding:20px 0 0 0;display:block;line-height:28px;letter-spacing:1px;color:#a8a8a8">{{item.des}}</span>
            </div>
          </div>
        </div>
        <div class="clearBoth"></div>
        
      </div>
    </div>
    <!-- <footerComponent/> -->
</div>
</template>
<script>
import { getList,cate } from '@/api/index.js'
import moduleTit from '@/components/moduleTit'
export default {
  name: 'App',
   components:{
    moduleTit
  },
  data() {  
    return {  
      curImg:{},
      newsInfo:{}
    };  
  }, 
  filters:{
    filterDay(_date) {
      const _day = new Date(_date)
      return _day.getDate()
    },
    filterMonth(_date) {
      const _day = new Date(_date)
      return _day.getMonth()+1
    },
    filterYear(_date) {
      const _day = new Date(_date)
      return _day.getFullYear()
    }
  },
  mounted() {
    this.getIndexEvent()
    this.cateEvent()
  },
  methods:{
    filterItemsByPath(path,arr) {
      let _arr = []
      let newArr = []
      _arr = arr
      newArr =  _arr.filter(item => item.path === path);
      if (newArr.length > 0) {
        return newArr[0]; // 只取第一个匹配的对象
      } else {
        return {}; // 如果没有匹配的对象，返回空对象
      }
  },
    cateEvent() {
      cate().then((res)=>{
          this.curImg = this.filterItemsByPath('/#/news',res.data).banner[0]
      })
    },
    handleDetail(item) {
       this.$router.push({path: '/newsDetail',query:{id:item.id}})
    },
    getIndexEvent() {
      this.$nextTick(()=>{
        let _id = this.$route.query.id
        let _obj = {cateId:_id}
            getList(_obj).then((res)=>{
              this.newsInfo = res.data
              this.newsInfo.cateInfo.name = '新闻资讯'
            })

      })
    }
  }
}
</script>
<style lang="scss" scoped>
.one:hover{
      cursor: pointer;
    }
.containerOne{
  .one{
    width:100%;
    margin:0 0 50px 0
  }
}
.footWords{
  padding:20px 0;
  line-height: 30px;
}
.clearBoth {
  clear:both
}
.tit {
  margin:0 0 20px 0;
  span{
    display: block;
    padding:5px 0 10px 0;
  }
}
</style>
